import { ProductLineForManagementDto } from '@modeso/types__dgoods-products';
export interface ManageProductsResponse {
    products: ProductLineForManagementDto[];
    action: string;
}
